import Typography from '@mui/material/Typography'
import { useTranslation } from 'next-i18next'
import RectArrow from 'assets/icons/nucleo/18px_open-rect-arrow-in.svg'
import { Button } from 'components/common/Button'
import { styled } from 'styles/styled'
import {
  BodyContainerIncluded,
  MainContainerIncluded
} from './map/IncludedContainer.style'

const Container = styled(BodyContainerIncluded)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-top: 12px;
`

interface RegistrationListsProps {
  registredNumbers: number
  link: string
}

function RegistrationLists({ registredNumbers, link }: RegistrationListsProps) {
  const { t } = useTranslation('event')

  const handleClick = () => {
    window.open(link, '_blank')
  }

  return (
    <MainContainerIncluded>
      <Typography variant="h4">{t('registrationList')}</Typography>
      <Container>
        <Typography variant="h6" lineHeight={1.2}>
          {t('registered', { count: registredNumbers })}
        </Typography>
        <Button
          label={t('showList')}
          onClick={handleClick}
          rightIcon={<RectArrow />}
        />
      </Container>
    </MainContainerIncluded>
  )
}

export default RegistrationLists
